import { useMemo } from 'react';

import { useSessionAsync } from 'src/app/shared/hooks/session';
import { useSessionConfiguration } from 'src/app/shared/hooks/sessionConfiguration';
import { isLoaded } from 'src/app/shared/utils/async';

export function useIsMembershipEligibleCountry(): boolean {
	const { featureConfigs } = useSessionConfiguration();
	const session = useSessionAsync();

	return useMemo(() => {
		if (!isLoaded(session)) return false;
		if (!featureConfigs.membershipEnabled) return false;
		if (session.value.country.membershipProgram === null || !session.value.country.membershipProgram.id) return false;
		return true;
	}, [featureConfigs, session]);
}
